import React from 'react';
import './styles/DesignerStyles.css';

class DesignerButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isDisabled: false,
    };
  }

  handleClick = () => {
    if (typeof this.props.onClick === 'function') {
      this.props.onClick();
    }

    this.setState({ isDisabled: true });

    setTimeout(
      () => {
        this.setState({ isDisabled: false });
      },
      this.props.disabledDelay ? this.props.disabledDelay : 1000
    );
  };

  render() {
    return (
      <button
        style={this.props.style}
        disabled={this.props.disabled || this.state.isDisabled}
        type="button"
        onClick={this.handleClick}
        className={this.props.class}>
        {this.props.buttonText ? this.props.buttonText : ''}
      </button>
    );
  }
}

export default DesignerButton;
